module.exports = __webpack_public_path__ + "static/img/bwfstzs.2c9fb1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bwfstzs.jpg
// module id = dTiq
// module chunks = 31